import {
  CHANGE_PRE_MEMBERSHIP,
  CHANGE_PRE_STATUS,
  DELETE_PRE_USER,
  SET_PRE_USER,
  SET_CONTRIBUTOR,
  ADD_PRE_USER,
  EDIT_PRE_USER,
  PRE_COURSE_UNENROLL,
  DELETE_CONTRIBUTOR,
} from "../constant";

const initialState = [];

export const preCollageUserReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SET_PRE_USER: {
      state = [...payload];
      return state;
    }
    case SET_CONTRIBUTOR: {
      state = [...payload];
      return state;
    }
    case ADD_PRE_USER: {
      let temp = [...state];
      let index = temp.findIndex((user) => user.email === payload.email);
      if (index > -1) {
        temp[index] = payload;
      } else {
        temp = [payload, ...temp];
      }
      return temp;
    }
    case EDIT_PRE_USER: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload._id);
      if (index > -1) {
        temp[index] = payload;
      }
      return temp;
    }
    case CHANGE_PRE_STATUS: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload);
      if (index > -1) {
        temp[index].is_active = !temp[index].is_active;
      }
      return temp;
    }
    case CHANGE_PRE_MEMBERSHIP: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload._id);
      if (index > -1) {
        temp[index] = payload;
      }
      return temp;
    }
    case PRE_COURSE_UNENROLL: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload.user_id);
      if (index > -1) {
        temp[index].enroll_course = temp[index].enroll_course.filter(
          (_) => _.course_id !== payload.course_id
        );
        temp[index].enroll_count = temp[index].enroll_count - 1;
      }
      return temp;
    }
    case DELETE_PRE_USER: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload);
      if (index > -1) {
        temp.splice(index, 1);
      }
      return temp;
    }
    case DELETE_CONTRIBUTOR: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload);
      if (index > -1) {
        temp.splice(index, 1);
      }
      return temp;
    }
    default: {
      return state;
    }
  }
};
